import { BuyingSessionAssortmentType } from '@modules/common/models/enums'
import { ProductTypeForSearchFilterEnum } from '@modules/common/models/enums/SearchFilterEnums'
import { ISelectedFilter } from '@modules/wholesale/FilterModal'

const convertStringToCapitalCase = (string: string): string => {
  return string
    .split(' ')
    .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(' ')
}

export const getProducts = (
  isRtlBuyView: boolean,
  assortmentType: string,
  assortmentProduct: {
    loading: boolean
    error: string
    items: any[]
  },
  collectionBuyingSessionProducts,
  filterProductsBasedOnFilterAndSearch,
  searchKey: string,
  wsAppliedFilters: ISelectedFilter,
  clusterAssortmentProducts,
  allBSPs,
  sortProductsBasedOnSortType,
  retailBuyProducts,
  selectedSortType,
  retailBuyProductsLength,
  zoneId?,
  node?: {
    categoryIds: string[]
    childrenMeta: string[]
  }
) => {
  const assortmentProducts =
    !isRtlBuyView &&
    assortmentType !== BuyingSessionAssortmentType.cluster &&
    collectionBuyingSessionProducts?.reduce((finalProducts, product) => {
      if (
        assortmentProduct?.items.includes(product.Id) &&
        (node
          ? node?.categoryIds?.includes(
              product.Original[convertStringToCapitalCase(node.childrenMeta?.[0])]?.Id
            )
          : true)
      ) {
        finalProducts.push({
          Original: product
        })
      }
      return finalProducts
    }, [])

  const products = filterProductsBasedOnFilterAndSearch(
    isRtlBuyView
      ? allBSPs?.findVIPBuyingSessionProduct?.Items || []
      : assortmentType === BuyingSessionAssortmentType.cluster
      ? clusterAssortmentProducts ?? []
      : assortmentProducts ?? [],
    searchKey,
    wsAppliedFilters,
    isRtlBuyView
      ? ProductTypeForSearchFilterEnum.buyingSessionProduct
      : ProductTypeForSearchFilterEnum.assortmentProduct
  )

  return retailBuyProductsLength && isRtlBuyView && selectedSortType
    ? sortProductsBasedOnSortType(
        products ?? [],
        selectedSortType,
        retailBuyProducts,
        zoneId
      )
    : products
}
